import { AxiosError, AxiosRequestConfig, Method } from 'axios'

import { axiosInstance as axios } from './axiosInstance'

interface BaseQueryFnParameters {
  url: string
  method?: Method
  data?: AxiosRequestConfig['data']
  params?: AxiosRequestConfig['params']
  headers?: AxiosRequestConfig['headers']
}

export const callProcedure = async <T = any>({
  url,
  method = 'POST',
  data,
  params,
  headers,
}: BaseQueryFnParameters) => {
  try {
    const result = await axios<T>({
      url,
      method,
      data,
      params,
      headers,
    })

    return {
      data: result.data,
    }
  } catch (axiosError) {
    const err = axiosError as AxiosError

    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    }
  }
}
